import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { BehaviorSubject, Observable, throwError } from "rxjs";
import { catchError, filter, switchMap, take } from "rxjs/operators";
import { AuthService } from "../auth.service";

@Injectable()
export class RequestInterceptor implements HttpInterceptor {
    constructor(public authService: AuthService, private router: Router) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const isAuthRoute = request.url.includes("Auth");
        const isS3Route = request.url.toLowerCase().includes("s3");
        const isVindi = request.url.toLowerCase().includes("vindi");
        const isRelativeRoute = !request.url.startsWith("http");
        const isPublicRoute = window.location.pathname.startsWith("/public/");

        if (isAuthRoute || isS3Route || isRelativeRoute || isPublicRoute || isVindi) {
            return next.handle(request);
        }

        const accessToken = this.authService.getAccessToken();

        if (accessToken) {
            request = this.addToken(request, accessToken);
        }

        return next.handle(request).pipe(
            catchError((error) => {
                if (error instanceof HttpErrorResponse && error.status === 401) {
                    return this.handle401Error(request, next);
                } else {
                    return throwError(error);
                }
            })
        );
    }

    private addToken(request: HttpRequest<any>, token: string) {
        return request.clone({
            setHeaders: {
                Authorization: `Bearer ${token}`
            }
        });
    }

    private isRefreshing = false;
    private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

    private handle401Error(request: HttpRequest<any>, next: HttpHandler) {
        if (!this.isRefreshing) {
            this.isRefreshing = true;
            this.refreshTokenSubject.next(null);

            return this.authService.applyRefreshToken().pipe(
                switchMap((refresh: any) => {
                    this.isRefreshing = false;
                    if (!refresh.sucess) {
                        this.refreshTokenSubject.next(null);

                        this.authService.logout().subscribe(() => {
                            if (location.hostname == "localhost") this.router.navigate(["/"]);
                            else
                                window.location.href = `${location.origin}/app/auth/credenciais?callbackUrl=/admin${this.router.url}`;
                        });
                    } else {
                        const accessToken = this.authService.getAccessToken();

                        this.refreshTokenSubject.next(accessToken);
                        return next.handle(this.addToken(request, accessToken));
                    }
                }),
                catchError((e) => {
                    console.log("error ", e);
                    if (e instanceof HttpErrorResponse && e.status === 401) {
                        this.authService.logout().subscribe(() => {
                            if (location.hostname == "localhost") this.router.navigate(["/"]);
                            else
                                window.location.href = `${location.origin}/app/auth/credenciais?callbackUrl=/admin${this.router.url}`;
                        });
                    } else {
                        return throwError(e);
                    }
                })
            );
        } else {
            return this.refreshTokenSubject.pipe(
                filter((token) => token != null),
                take(1),
                switchMap((jwt) => {
                    return next.handle(this.addToken(request, jwt));
                })
            );
        }
    }
}
